export default __webpack_public_path__ + "static/media/Impact.1a432a69.svg";